import { render, staticRenderFns } from "./create-dialog.vue?vue&type=template&id=621d7140&"
import script from "./create-dialog.vue?vue&type=script&lang=js&"
export * from "./create-dialog.vue?vue&type=script&lang=js&"
import style0 from "./create-dialog.vue?vue&type=style&index=0&id=621d7140&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports